<template lang="pug">
div
  section.section.main-content
    .container
      .header
        a(@click="backToTeam()") Regresar
        h4.title.is-4 {{executiveName}}
        p.subtitle Brokers asignados
      b-table(:data="data")
        template(slot-scope='props')
          b-table-column(field='id' label='ID')
            p {{props.row.id}}
          b-table-column(field='first_name' label='Nombres')  
            p {{props.row.first_name}}
          b-table-column(field='last_name' label='Apellidos')
            p {{props.row.last_name}}
          b-table-column(field='email' label='Correo')
            p {{props.row.email}}
          b-table-column(field='phone' label='Celular')
            p {{props.row.phone}}
          b-table-column(class="reallocation-wrapper" label='Asignación')
            ReallocationBrokers(:owner="executiveName", :broker="props.row" @swapSuccess="reloadInfo")
</template>
<script>
import { isTechnicalTeamSupervisor, isExecutiveTeamSupervisor } from '@/mixins/user';
import { getBrokersAsignToExecutive } from '../services/User/executive';
import ReallocationBrokers from "../components/ReallocationBrokers.vue";
export default {
    name:"Equipo",
    components: {
      ReallocationBrokers
    },
    data() {
      return {
        data: [],
        executiveName: "",
        executiveList: []
      }
    },
    mounted() {
      isTechnicalTeamSupervisor() ? this.technicalOperativesList() : null;
      isExecutiveTeamSupervisor() ? this.executiveOperativesList() : null;
      console.log("id de broker", this.$route.params.operatives)
      this.executiveList = this.$route.params.operatives
    },

    methods: {
      backToTeam(){
        this.$router.push('/team')
        
      },

      executiveOperativesList() {
        getBrokersAsignToExecutive(this.$route.params.id).then( (result) => {
          this.data = result.data.assigned_brokers;
          this.executiveName = result.data.full_name
        })
      },

      reloadInfo() {
        console.log("reload")
        this.executiveOperativesList()
      }
    }
}
</script>
<style scoped>
.reallocation-wrapper{
  padding-top: 3px;
}
</style>